function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.102 0h11.796A4.106 4.106 0 0120 4.102V10.7a4.106 4.106 0 01-4.102 4.102H4.102A4.106 4.106 0 010 10.7v-6.6A4.106 4.106 0 014.102 0z",
  fill: "#6787F5"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.898 0H10v14.803h5.898A4.106 4.106 0 0020 10.7v-6.6A4.106 4.106 0 0015.898 0z",
  fill: "#38478A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.815h-4.927l3.668-3.668A4.088 4.088 0 0015.898 0h-.982l-2.328 2.329V0H7.413v2.329L5.083 0h-.981a4.088 4.088 0 00-2.843 1.147l3.668 3.668H0V9.99h4.927l-3.53 3.53-.137.136a4.087 4.087 0 002.842 1.147h.608l2.64-2.265-.04 2.265h5.277v-2.321l2.313 2.32h.998a4.087 4.087 0 002.832-1.137l-.138-.138-3.525-3.537H20V4.815z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.815h-4.927l3.668-3.668A4.088 4.088 0 0015.898 0h-.982l-2.328 2.329V0H10v14.803h2.587v-2.321l2.313 2.32h.998a4.087 4.087 0 002.832-1.137l-.138-.138-3.525-3.537H20V4.815z",
  fill: "#C7D3ED"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.416 5.986V0H8.584v5.986H0v2.832h8.584l-.1 5.985h2.932V8.818H20V5.986h-8.584z",
  fill: "#FF337A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.416 5.986V0H10v14.803h1.416V8.818H20V5.986h-8.584z",
  fill: "#D1005B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.803 5.205v-.829L3.474.048a4.07 4.07 0 00-1.25.407l4.75 4.75h.83z",
  fill: "#FF337A"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M17.776.455a4.069 4.069 0 00-1.25-.407l-4.329 4.328v.829h.829l4.75-4.75z",
  fill: "#D1005B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.227 14.348c.385.199.806.339 1.25.407l4.327-4.327v-.829h-.829l-4.748 4.749z",
  fill: "#FF337A"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.197 9.6v.83l4.313 4.327a4.072 4.072 0 001.253-.403L13.023 9.6h-.826z",
  fill: "#D1005B"
});

function SvgColoredEnFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgColoredEnFlag;